import client from "./client";

const testsApi = {
  list(params = {}) {
    return client.get("/tests", { params }).then((r) => r.data);
  },

  get(id) {
    return client.get(`/tests/${id}`).then((r) => r.data);
  },

  create(body) {
    return client.post("/tests", body).then((r) => r.data);
  },

  update(id, body) {
    return client.patch(`/tests/${id}`, body).then((r) => r.data);
  },

  delete(id) {
    return client.delete(`/tests/${id}`).then((r) => r.data);
  },

  // ── Question Bank Integration ─────────────────────────────────────────

  // Add questions from bank to test
  addQuestions(testId, questionIds) {
    return client
      .post(`/tests/${testId}/questions`, { questionIds })
      .then((r) => r.data);
  },

  // Auto-generate test from question bank
  generate(testId, config) {
    return client
      .post(`/tests/${testId}/generate`, config)
      .then((r) => r.data);
  },

  // Get test paper with questions
  getQuestions(testId) {
    return client
      .get(`/tests/${testId}/questions`)
      .then((r) => r.data);
  },

  // Reorder questions in test
  reorderQuestions(testId, questionOrders) {
    return client
      .patch(`/tests/${testId}/questions/reorder`, { questionOrders })
      .then((r) => r.data);
  },

  // Remove question from test
  removeQuestion(testId, testQuestionId) {
    return client
      .delete(`/tests/${testId}/questions/${testQuestionId}`)
      .then((r) => r.data);
  },

  // ── Student Test Taking ───────────────────────────────────────────────

  // Start test for student
  start(testId, studentId) {
    return client
      .post(`/tests/${testId}/start`, { studentId })
      .then((r) => r.data);
  },

  // Save student response
  saveResponse(responseId, data) {
    return client
      .patch(`/tests/responses/${responseId}`, data)
      .then((r) => r.data);
  },

  // Auto-grade MCQ response
  autoGrade(responseId) {
    return client
      .post(`/tests/responses/${responseId}/auto-grade`)
      .then((r) => r.data);
  },

  // Manual grade response
  gradeResponse(responseId, gradeData) {
    return client
      .patch(`/tests/responses/${responseId}/grade`, gradeData)
      .then((r) => r.data);
  },

  // Finalize test and calculate totals
  finalize(testId, studentId) {
    return client
      .post(`/tests/${testId}/finalize`, { studentId })
      .then((r) => r.data);
  },

  // ── Results & Analytics ───────────────────────────────────────────────

  // Get question-wise results
  getResults(testId, studentId) {
    return client
      .get(`/tests/${testId}/results`, { params: { studentId } })
      .then((r) => r.data);
  },

  // Get class analytics
  getAnalytics(testId) {
    return client
      .get(`/tests/${testId}/analytics`)
      .then((r) => r.data);
  },
};

export default testsApi;
